import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { MatButtonModule } from "@angular/material/button";
import { Observable, of } from "rxjs";
import { TeknikerPasswordCapabilityService } from "@e-forsyning/common/auth";
import { ServiceProCookieConsentButtonComponent } from "../../cookie-consent/service-pro-cookie-consent-button.component";
import { webVersion } from "./web-version";

export interface UserInfoData {
    user: {
        initialer?: string;
        name: string;
        email: string;
        phone: string;
    };
    works: {
        name: string;
        address: string;
        phone: string;
    };
}

@Component({
    selector: "user-info",
    imports: [CommonModule, MatButtonModule, ServiceProCookieConsentButtonComponent],
    templateUrl: "./user-info.html",
    styleUrl: "./user-info.scss"
})
export class UserInfo implements OnInit {
    @Input()
    public data: UserInfoData;
    @Output()
    public close = new EventEmitter<void>();

    public readonly webVersion = webVersion;
    public readonly klientLabel = Capacitor.isNativePlatform() ? "app" : "browser";
    public teknikerPasswordFeaturesSupported$: Observable<boolean> = of(false);

    private readonly router = inject(Router);
    private readonly teknikerPasswordCapability = inject(TeknikerPasswordCapabilityService);

    public ngOnInit(): void {
        this.teknikerPasswordFeaturesSupported$ = this.teknikerPasswordCapability.supportsTeknikerPasswordFeatures$();
    }

    public onClose(): void {
        this.close.emit();
    }

    public onSkiftAdgangskode(): void {
        this.close.emit();
        void this.router.navigateByUrl("/skift-kodeord");
    }
}
